// extracted by mini-css-extract-plugin
export default {"dark":"CallHistory_dark__cFxEn","callHistorySection":"CallHistory_callHistorySection__bjlgz","dateInputGroup":"CallHistory_dateInputGroup__k80pQ"};